import React from 'react';

import { SvgProps } from '../enums';

export const FlagFJ: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_54996"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_54996)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#67BFE5"
      />
      <mask
        id="mask1_270_54996"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_54996)">
        <mask
          id="mask2_270_54996"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="9"
          height="7"
        >
          <rect width="9" height="7" fill="white" />
        </mask>
        <g mask="url(#mask2_270_54996)">
          <path
            // eslint-disable-next-line max-len
            d="M-1.00208 6.4999L0.9784 7.3685L9.045 0.944361L10.0897 -0.346405L7.97182 -0.636717L4.68165 2.13163L2.0334 3.99685L-1.00208 6.4999Z"
            fill="#F7FCFF"
          />
          <path
            d="M-0.730957 7.10845L0.278004 7.61252L9.71451 -0.466339H8.29782L-0.730957 7.10845Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M10.0022 6.4999L8.02172 7.3685L-0.0448761 0.944361L-1.08953 -0.346405L1.0283 -0.636717L4.31847 2.13163L6.96673 3.99685L10.0022 6.4999Z"
            fill="#F7FCFF"
          />
          <path
            // eslint-disable-next-line max-len
            d="M9.93457 6.93667L8.92561 7.44073L4.90745 3.98176L3.71615 3.59529L-1.1901 -0.341973H0.226597L5.13009 3.50184L6.43256 3.96525L9.93457 6.93667Z"
            fill="#F50100"
          />
          <mask
            id="path-9-outside-1_270_54996"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="11"
            height="9"
            fill="black"
          >
            <rect fill="white" x="-1" y="-1" width="11" height="9" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.99226 0H3.99226V3H0V4H3.99226V7H4.99226V4H9V3H4.99226V0Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.99226 0H3.99226V3H0V4H3.99226V7H4.99226V4H9V3H4.99226V0Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M3.99226 0V-0.75H3.24226V0H3.99226ZM4.99226 0H5.74226V-0.75H4.99226V0ZM3.99226 3V3.75H4.74226V3H3.99226ZM0 3V2.25H-0.75V3H0ZM0 4H-0.75V4.75H0V4ZM3.99226 4H4.74226V3.25H3.99226V4ZM3.99226 7H3.24226V7.75H3.99226V7ZM4.99226 7V7.75H5.74226V7H4.99226ZM4.99226 4V3.25H4.24226V4H4.99226ZM9 4V4.75H9.75V4H9ZM9 3H9.75V2.25H9V3ZM4.99226 3H4.24226V3.75H4.99226V3ZM3.99226 0.75H4.99226V-0.75H3.99226V0.75ZM4.74226 3V0H3.24226V3H4.74226ZM0 3.75H3.99226V2.25H0V3.75ZM0.75 4V3H-0.75V4H0.75ZM3.99226 3.25H0V4.75H3.99226V3.25ZM4.74226 7V4H3.24226V7H4.74226ZM4.99226 6.25H3.99226V7.75H4.99226V6.25ZM4.24226 4V7H5.74226V4H4.24226ZM9 3.25H4.99226V4.75H9V3.25ZM8.25 3V4H9.75V3H8.25ZM4.99226 3.75H9V2.25H4.99226V3.75ZM4.24226 0V3H5.74226V0H4.24226Z"
            fill="#F7FCFF"
            mask="url(#path-9-outside-1_270_54996)"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 5H14.8276V9.16667C14.8276 9.16667 14.4228 11 12.4138 11C10.4048 11 10 9.16667 10 9.16667V5Z"
          fill="#F7FCFF"
        />
        <mask
          id="mask3_270_54996"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="10"
          y="5"
          width="5"
          height="6"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 5H14.8276V9.16667C14.8276 9.16667 14.4228 11 12.4138 11C10.4048 11 10 9.16667 10 9.16667V5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_270_54996)">
          <rect x="10" y="5" width="4.82759" height="1.5" fill="#C3352C" />
          <rect
            x="12.069"
            y="6.33334"
            width="0.689655"
            height="4.66667"
            fill="#C3352C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8.16666H14.8276V8.83332H10V8.16666Z"
            fill="#C3352C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M11.2702 10.3685C11.5605 10.7789 11.7971 10.939 11.9643 10.6972C12.0818 10.5273 12.0939 10.3573 11.9265 10.3241C11.8294 10.2006 11.7608 10.1044 11.7217 10.0372L11.7273 10.0319C11.7743 9.98629 11.776 9.92542 11.7668 9.90272C11.7633 9.87166 11.7865 9.82947 11.9374 9.71413C12.074 9.60967 12.1346 9.51131 12.0451 9.40298C11.998 9.34604 11.9557 9.33463 11.8223 9.31402L11.7813 9.30765C11.7418 9.30131 11.7131 9.29502 11.695 9.28958L11.6022 9.11177C11.4084 9.10585 11.257 9.14001 11.0913 9.20995C11.0199 9.24008 10.9718 9.26056 10.9398 9.27423C10.8909 9.29503 10.8791 9.30005 10.8788 9.2993C10.8786 9.29906 10.8797 9.29825 10.881 9.29717C10.8848 9.29414 10.8913 9.28905 10.882 9.28905C10.847 9.28905 10.8092 9.28512 10.7042 9.27179L10.6836 9.26919C10.3819 9.23128 10.3063 9.23246 10.2574 9.37296C10.183 9.5867 10.6235 9.97849 10.8573 10.0256C10.9745 10.0491 11.1147 10.1613 11.2702 10.3685ZM11.5984 10.0743C11.6267 10.0743 11.6486 10.0731 11.6679 10.0679L11.6737 10.0551C11.658 10.0658 11.6344 10.0743 11.5984 10.0743ZM10.497 9.48407C10.4909 9.47683 10.4892 9.46747 10.4935 9.45514C10.4926 9.45768 10.4954 9.46317 10.5013 9.47096C10.5071 9.47862 10.5158 9.48852 10.5269 9.50006C10.5135 9.49622 10.5031 9.49115 10.497 9.48407ZM10.9067 9.78048C10.8228 9.76361 10.6097 9.58625 10.5269 9.50006C10.5486 9.50628 10.5782 9.50931 10.61 9.51256C10.6239 9.51398 10.6382 9.51544 10.6525 9.51724L10.6727 9.5198C10.7907 9.53478 10.8318 9.53905 10.882 9.53905C10.9109 9.53905 10.9049 9.54903 10.9013 9.55508C10.9002 9.55695 10.8993 9.55844 10.8997 9.55915C10.9014 9.562 10.9242 9.55234 11.0381 9.50397L11.0381 9.50397L11.1885 9.44026C11.2771 9.40289 11.3579 9.37868 11.4466 9.36779C11.4564 9.40966 11.4807 9.44752 11.5204 9.47831C11.5737 9.51961 11.6338 9.53697 11.7372 9.55378C11.6087 9.65956 11.5441 9.74807 11.5238 9.83438C11.4081 9.87095 11.4187 10.0013 11.488 10.1315C11.5364 10.2223 11.6278 10.351 11.7638 10.5212L11.8615 10.5682C11.8326 10.5682 11.8165 10.555 11.8043 10.545C11.7889 10.5323 11.7796 10.5247 11.7586 10.555C11.7572 10.5571 11.6663 10.4955 11.4723 10.2213C11.2812 9.96676 11.096 9.81859 10.9067 9.78048ZM11.5164 9.93029C11.5181 9.92883 11.5179 9.92689 11.5177 9.92494L11.5177 9.92488L11.5164 9.93029ZM11.5963 9.82431L11.5888 9.82442L11.5923 9.82468C11.5937 9.82446 11.595 9.82436 11.5963 9.82431ZM11.5984 9.82428C11.5977 9.82428 11.597 9.82429 11.5963 9.82431L11.5984 9.82428Z"
            fill="#979797"
          />
          <path
            d="M10.8275 8.05511C10.8275 8.05511 10.589 7.7251 10.589 7.60745"
            stroke="#964C36"
            strokeWidth="0.5"
          />
          <path
            d="M10.6794 7.77143C10.6794 7.77143 10.3744 7.64117 10.3744 7.77143"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            d="M10.6744 7.63445C10.6744 7.63445 10.4599 7.36154 10.2986 7.36154C10.1374 7.36154 10.1412 7.498 10.1412 7.498"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            d="M10.552 7.36099C10.552 7.36099 10.4563 6.91461 10.303 6.91461C10.1497 6.91461 10.1497 7.1378 10.1497 7.1378"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            d="M10.5907 7.36012C10.5907 7.36012 10.548 6.97757 10.7454 6.97757"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            d="M11.1306 7.99056C11.1306 7.99056 11.0193 7.59886 11.0596 7.48831"
            stroke="#964C36"
            strokeWidth="0.5"
          />
          <path
            d="M11.0884 7.67333C11.0884 7.67333 10.8464 7.44661 10.8018 7.56901"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            // eslint-disable-next-line max-len
            d="M11.1306 7.54292C11.1306 7.54292 11.0224 7.2131 10.8708 7.15794C10.7192 7.10278 10.6762 7.23232 10.6762 7.23232"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            // eslint-disable-next-line max-len
            d="M11.1091 7.24409C11.1091 7.24409 11.1718 6.79188 11.0277 6.73945C10.8837 6.68701 10.8073 6.89674 10.8073 6.89674"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            d="M11.1457 7.25652C11.1457 7.25652 11.2364 6.88243 11.4219 6.94995"
            stroke="#2A8E51"
            strokeWidth="0.5"
          />
          <path
            d="M11.3761 8.13007C11.3761 8.13007 11.5343 7.75486 11.5078 7.64023"
            stroke="#964C36"
            strokeWidth="0.35"
          />
          <path
            d="M11.4566 7.82033C11.4566 7.82033 11.7245 7.6248 11.7538 7.75172"
            stroke="#2A8E51"
            strokeWidth="0.35"
          />
          <path
            // eslint-disable-next-line max-len
            d="M11.4306 7.68575C11.4306 7.68575 11.5783 7.37158 11.7354 7.3353C11.8926 7.29902 11.9195 7.43284 11.9195 7.43284"
            stroke="#2A8E51"
            strokeWidth="0.35"
          />
          <path
            d="M11.4884 7.39175C11.4884 7.39175 11.4813 6.93528 11.6306 6.90079C11.78 6.8663 11.8302 7.08377 11.8302 7.08377"
            stroke="#2A8E51"
            strokeWidth="0.35"
          />
          <path
            d="M11.4505 7.3996C11.4505 7.3996 11.406 7.01725 11.2137 7.06166"
            stroke="#2A8E51"
            strokeWidth="0.35"
          />
          <path
            d="M13.349 7.90094C13.349 7.90094 13.47 7.34421 13.8143 7.34421C14.1586 7.34421 14.3127 7.93241 14.3127 7.93241"
            stroke="#2A8E51"
            strokeWidth="0.35"
          />
          <path
            d="M13.0647 7.52085C13.0647 7.52085 13.2501 7.192 13.862 7.21889C14.474 7.24578 14.5855 7.52085 14.5855 7.52085"
            stroke="#2A8E51"
            strokeWidth="0.35"
          />
          <path
            // eslint-disable-next-line max-len
            d="M12.941 7.10268C12.941 7.10268 13.2772 6.68632 13.7483 7.03924L13.9079 7.10268C13.9079 7.10268 14.0679 6.63084 14.841 7.10268"
            stroke="#2A8E51"
            strokeWidth="0.35"
          />
          <path
            d="M13.8692 8.01848C13.8692 8.01848 13.8938 7.49884 13.9762 7.35611"
            stroke="#964C36"
            strokeWidth="0.5"
          />
          <path
            // eslint-disable-next-line max-len
            d="M14.5494 9.15694C14.5494 9.15694 14.2403 9.01158 14.1478 9.15694C14.0554 9.30229 12.9414 10.6378 12.9414 10.6378"
            stroke="#964C36"
            strokeWidth="0.5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M13.4822 9.2976L14.1726 9.78022C14.1726 9.78022 14.4903 9.55355 14.3315 9.42557C14.1726 9.2976 13.7397 9.07196 13.7397 9.07196L13.4822 9.2976Z"
            fill="#FFF203"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M13.4583 9.32227C13.4583 9.32227 13.2984 9.48971 13.2984 9.61768C13.2984 9.74566 13.1495 10.0887 13.1495 10.0887C13.1495 10.0887 13.5657 10.3449 13.6522 10.1817C13.7386 10.0185 14.2999 10.1162 14.2009 9.86696C14.1019 9.61768 13.4583 9.32227 13.4583 9.32227Z"
            fill="#00A651"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M10.5281 5.59113C10.5281 5.59113 10.8968 5.40197 11.0792 5.59113C11.2617 5.7803 11.4112 5.57546 11.4112 5.46135C11.4112 5.34724 11.701 4.9555 11.701 5.27332C11.701 5.59113 11.6108 5.77058 11.8655 5.77058C12.1202 5.77058 13.2671 5.33157 13.5421 5.46135C13.8171 5.59113 14.0275 5.55886 13.9576 5.37264C13.8877 5.18642 13.708 5.07003 13.3621 5.17167C13.0161 5.27332 13.0977 5.37264 12.7987 5.37264C12.4997 5.37264 12.1669 5.27332 12.1669 5.27332C12.1669 5.27332 12.2604 5.10632 12.6018 5.22511C12.9431 5.3439 13.414 5.078 13.5421 5.078C13.6701 5.078 14.0226 5.07003 14.0575 5.17167C14.0925 5.27332 14.3053 5.36659 14.143 5.46135C13.9808 5.55611 13.7133 5.61546 13.8974 5.73687C14.0814 5.85828 14.5047 5.83488 14.5251 5.96116C14.5454 6.08745 14.746 6.27603 14.6655 6.27603C14.585 6.27603 14.4395 6.45388 14.3041 6.39973C14.1686 6.34558 14.1526 6.29803 14.2826 6.25416C14.4125 6.21029 14.4112 6.0258 14.3041 6.0258C14.1969 6.0258 14.2492 6.09044 14.0052 6.0258C13.7613 5.96116 13.4384 5.88931 13.4578 6.0258C13.4772 6.16229 13.6361 6.37181 13.343 6.39973C13.05 6.42765 12.9128 6.53976 12.8558 6.44948C12.7987 6.3592 12.5948 6.2389 12.7552 6.20033C12.9155 6.16175 13.0687 6.33145 13.1264 6.30374C13.1842 6.27603 13.315 6.26061 13.2054 6.1432C13.0958 6.0258 12.9151 5.95668 13.0826 5.8688C13.2502 5.78093 13.1179 5.77912 12.7987 5.96116C12.4795 6.1432 12.3019 6.2979 12.0217 6.27603C11.7414 6.25416 11.6365 6.28367 11.5464 6.25416C11.4563 6.22465 11.0176 6.5802 10.8913 6.48996C10.7649 6.39973 10.3571 6.36511 10.4305 6.25416C10.5039 6.1432 10.6025 6.08608 10.7123 6.1432C10.8221 6.20033 10.9312 6.25745 11.0052 6.20033C11.0792 6.1432 11.293 5.94719 11.2393 5.908C11.1855 5.8688 11.2375 5.73687 10.933 5.73687C10.6285 5.73687 10.5215 5.88391 10.4492 5.79126C10.3769 5.69862 10.5281 5.59113 10.5281 5.59113Z"
            fill="#FFD100"
          />
        </g>
      </g>
    </g>
  </svg>
);
